import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { decode } from '@mapbox/polyline';
import { withStyles } from '@material-ui/core/styles';
import { Polyline, Popup } from 'react-leaflet';
import { getColor } from './styles';
import PolylineDecorator from './PolylineDecorator';
var styles = {
  polyline: {
    strokeWidth: 10,
    'box-shadow': 'inset 0 1px 2px rgba(0, 0, 0, 0.25)'
  }
};

var Route =
/*#__PURE__*/
function (_Component) {
  _inherits(Route, _Component);

  function Route() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Route);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Route)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      bounds: undefined,
      polyline: undefined
    }, _this.componentDidMount = function () {
      _this.parserProps(_this.props);
    }, _this.componentWillReceiveProps = function (props) {
      _this.parserProps(props);
    }, _this.parserProps = function (props) {
      if (typeof props.path === 'string') {
        _this.setState({
          polyline: decode(props.path).map(function (c) {
            return {
              lat: c[0],
              lng: c[1]
            };
          })
        }, _this.setBounds);
      } else {
        _this.setState({
          polyline: props.path
        }, _this.setBounds);
      }
    }, _this.setBounds = function (props) {
      var polyline = _this.state.polyline;
      var onBounds = _this.props.onBounds;

      if (polyline === undefined) {
        return;
      }

      var minLat = undefined,
          minLng = undefined,
          maxLat = undefined,
          maxLng = undefined;
      polyline.forEach(function (c) {
        minLat = Math.min(minLat || c.lat, c.lat);
        minLng = Math.min(minLng || c.lng, c.lng);
        maxLat = Math.max(maxLat || c.lat, c.lat);
        maxLng = Math.max(maxLng || c.lng, c.lng);
      });

      _this.setState({
        bounds: [[minLat, minLng], [maxLat, maxLng]]
      });

      if (onBounds) {
        onBounds([[minLat, minLng], [maxLat, maxLng]]);
      }
    }, _this.handleOnClick = function () {
      var onClick = _this.props.onClick;

      if (onClick) {
        onClick();
      }
    }, _temp));
  }

  _createClass(Route, [{
    key: "render",
    value: function render() {
      var polyline = this.state.polyline;
      var _this$props = this.props,
          classes = _this$props.classes,
          key = _this$props.key,
          children = _this$props.children,
          color = _this$props.color,
          selected = _this$props.selected,
          onBounds = _this$props.onBounds,
          label = _this$props.label,
          zoomLevel = _this$props.zoomLevel;
      var childArray = React.Children.toArray(children);
      return React.createElement(React.Fragment, null, polyline && React.createElement(Polyline, {
        key: key,
        positions: polyline,
        color: 'red',
        opacity: 0,
        fillOpacity: 0,
        className: classes.polyline,
        onClick: this.handleOnClick
      }), polyline && React.createElement(Polyline, {
        key: key,
        positions: polyline,
        color: getColor(color),
        className: selected && classes.polyline,
        onClick: this.handleOnClick
      }, label && React.createElement(Popup, null, label)), polyline && zoomLevel > 13 && React.createElement(PolylineDecorator, {
        positions: polyline,
        selected: selected,
        color: selected ? '#FFFFFF' : getColor(color),
        onClick: this.handleOnClick
      }), React.Children.map((childArray || []).filter(function (ch) {
        return ch !== undefined && ch !== null && ch !== false;
      }), function (ch, idx) {
        return React.cloneElement(ch, {
          color: color,
          onBounds: onBounds,
          zoomLevel: zoomLevel
        });
      }));
    }
  }]);

  return Route;
}(Component);

Route.propTypes = {
  path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired
  }))]).isRequired,
  key: PropTypes.any,
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selected: PropTypes.bool,
  onBounds: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, Element]),
  zoomLevel: PropTypes.number
};
export default withStyles(styles)(Route);